import React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Skeleton from '@mui/material/Skeleton'
import IconTooltipButton from '../../../../../button/IconTooltipButton'

// MF-543 — summary of who a chart is visible for + who it's the default for, so the default chart
// (and its audience) is easy to spot in the list. `accessRole` comes populated as role objects
// (name); `defaultForRole` is a list of role ids (a subset of accessRole) → resolve their names.
const ChartAudience = ({ item }) => {
  const accessRoles = item?.accessRole || []
  const defaultIds = (item?.defaultForRole || []).map((id) => String(id))
  if (!accessRoles.length) {
    return (
      <Typography variant='caption' className='text-muted-foreground opacity-70'>
        Not shared with any role
      </Typography>
    )
  }
  return (
    <div className='flex flex-wrap items-center gap-1 mt-1'>
      {accessRoles.map((role) => {
        const isDefault = defaultIds.includes(String(role._id))
        return (
          <Chip
            key={role._id}
            size='small'
            label={isDefault ? `★ ${role.name} · default` : role.name}
            color={isDefault ? 'primary' : 'default'}
            variant={isDefault ? 'filled' : 'outlined'}
          />
        )
      })}
    </div>
  )
}

const AnalyticsChartsList = ({ list = [], isLoading, permissions, onModal }) => {
  if (isLoading) {
    return (
      <List>
        {Array(4)
          .fill()
          .map((_, i) => (
            <ListItem key={i}>
              <ListItemIcon>
                <Skeleton variant='circular' width='2rem' height='2rem' />
              </ListItemIcon>
              <Skeleton variant='text' width={300} />
            </ListItem>
          ))}
      </List>
    )
  }
  if (list.length === 0)
    return (
      <Typography variant='inherit' component={'p'} className='text-muted-foreground opacity-50 py-2'>
        You don&apos;t have any analytics chart yet
      </Typography>
    )
  return (
    <List>
      {list.map((item) => (
        <ListItem button key={item._id}>
          <ListItemIcon>
            <div className='size-8 flex items-center justify-center bg-primary text-primary-foreground rounded-full'>
              {item.position}
            </div>
          </ListItemIcon>
          <ListItemText
            primary={item?.name}
            secondary={<ChartAudience item={item} />}
            secondaryTypographyProps={{ component: 'div' }}
          />
          <ListItemSecondaryAction>
            {permissions['preview'] && (
              <IconTooltipButton title='Preview' icon='expand-alt' onClick={() => onModal('preview', item)} />
            )}
            {permissions['updated'] && (
              <IconTooltipButton title='Edit' icon={['fas', 'edit']} onClick={() => onModal('edit', item)} />
            )}
            {permissions['deleted'] && (
              <IconTooltipButton
                title='Delete'
                icon={['fas', 'trash-alt']}
                onClick={() => onModal('delete', item)}
              />
            )}
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  )
}

export default AnalyticsChartsList
